import React from 'react'

import Icon from 'common/components/general/Icon'

interface UserItemProps {
  title: string
  icon: string
}

const UserInfoItem: React.FC<UserItemProps> = ({ title, icon }) => {
  return (
    <div className="flex flex__center">
      <div>
        <Icon type={`far fa-${icon}`} fontAwesome className="color-gray-6 mr-8" />
      </div>
      <span>{title}</span>
    </div>
  )
}

export default UserInfoItem
